package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_client_data_di_ClientModule : Module get() = module {
	single() { _ -> com.essntl.features.client.data.repository.ClientRepositoryImpl(supabase=get()) } bind(com.essntl.features.client.domain.repository.ClientRepository::class)
	single() { _ -> com.essntl.features.client.data.supabase.ClientSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.client.data.supabase.ClientSupabaseDataSource::class)
}
public val com.essntl.features.client.data.di.ClientModule.module : org.koin.core.module.Module get() = com_essntl_features_client_data_di_ClientModule
